// extracted by mini-css-extract-plugin
export var container = "_fw-0";
export var segment = "_fw-2";
export var segmentActive = "_fw-3";
export var track = "_fw-1";